export default __webpack_public_path__ + "static/media/CarImages.PRunnerGallery5.ff8b25ec.jpg";